import { Container, Sprite, } from "pixi.js"
import rocketpng from "./Rocket4x.png"
import fireContainer from "./fire/fire"

let rocketContainer = new Container();
rocketContainer.position.set(158, 235)

let rocket = Sprite.from(rocketpng);
rocket.anchor.set(0.5, 0.5);
rocket.position.set(0, 0)
rocket.scale.set(0.25, 0.25)

rocketContainer.addChild(rocket);
rocketContainer.addChild(fireContainer);
rocketContainer.name = 'rocket'

export default rocketContainer

